import { HtsReadinessPillarKey } from "../constants";
import { HtsReadinessPillarConfig } from "../schemas";

export const specialSkills: HtsReadinessPillarConfig = {
  key: HtsReadinessPillarKey.SPECIAL_SKILLS,
  label: "Special Skills",
  definition:
    "Notable achievements and distinctive qualities that strengthen candidacy — additional languages, sporting, artistic, or academic achievements, life-saving actions, specialized licences and skills. This pillar scores sustained skill and follow-through in any field, and the operational value of specific skills.",
  dataSourceNote:
    "Asked — the open Special Skills question, cross-linked to the Section A language list (speak/read/write). Probes ask for the specifics that make a claim scoreable, never for more achievements.",
  dimensions: [
    {
      key: "levelOfAchievement",
      label: "Level of Achievement",
      weight: 0.25,
      anchors: {
        0: "No achievements or distinctive skills identified, even after the follow-up.",
        25: "Sustained pursuit without recognition: practised regularly over time, but no team selections, completed programs or awards.",
        50: "Sustained pursuit with some recognition: team selections, completed programs, school-level awards.",
        75: "Sustained pursuit to a high level, with or without formal recognition: regional or provincial sport, a trade or craft practised to proficiency, a skill relied on by others at work or in the community, notable artistic or academic distinction.",
        100: "Exceptional achievement: national-level competition, a life-saving action performed, or a rare distinction few candidates hold.",
      },
    },
    {
      key: "relevanceToHighTrustWork",
      label: "Relevance to High-Trust Work",
      weight: 0.45,
      anchors: {
        0: "No connection to the demands of high-trust work.",
        25: "General interest value only.",
        50: "Transferable value — team-sport discipline, performing under an audience, sustained practice habits.",
        75: "Directly useful: a second language (fluency in the language the role is worked in doesn't count), first aid beyond the standard first aid/CPR C the role requires, lifeguarding or first-responder-adjacent skills, licences beyond the driver's licence the role requires.",
        100: "Highly valuable to the target role: fluency in a language of the community served, a life-saving action performed under pressure, or credentials the agency itself seeks.",
      },
    },
    {
      key: "depthVerifiability",
      label: "Depth & Verifiability",
      weight: 0.3,
      anchors: {
        0: "Nothing offered.",
        25: "Vague claims without specifics, or only a minimum requirement for the role (standard first aid/CPR C, a driver's licence, fluency in the language the role is worked in), however well documented.",
        50: "Described with some specifics — what, when, where.",
        75: "Specific, dated, and verifiable on request.",
        100: "Documented or credentialed — certificates, rankings, records the candidate can produce — for a skill beyond the role's minimum requirements.",
      },
    },
  ],
  topIndicators: [
    "A language the community actually speaks",
    "A life saved",
    "An achievement with a date and a certificate behind it",
  ],
  scoringNotes: [
    "Language claims are scored against the Section A speak/read/write list, not the open answer alone.",
    "Participation alone (a membership, or taking part without a team selection, program or award) scores 10 on Level of Achievement.",
    "Minimum requirements for the role (standard first aid/CPR C and AED, a driver's licence, Grade 12) count, but score no higher than 25 on every dimension. Their paperwork is scored under Education, not here.",
    "Recreational video gaming never counts as a skill or achievement, however high the ranking.",
  ],
};
